import {
  apiClient,
} from './axios';

async function getFiles(folder, companyName, subfolder) {
  try {
    const res = await apiClient.get(`/googlestorage/files/${folder}/${companyName}/${subfolder}`);
    return res;
  } catch (error) {
    return error;
  }
}
async function getFilesExams() {
  try {
    const res = await apiClient.get('/googlestorage/files/exams');
    return res;
  } catch (error) {
    return error;
  }
}

async function getEWFilesGlobal() {
  try {
    const res = await apiClient.get('/googlestorage/ew/global');
    return res;
  } catch (error) {
    return error;
  }
}

async function getMWFilesGlobal() {
  try {
    const res = await apiClient.get('/googlestorage/mw/global');
    return res;
  } catch (error) {
    return error;
  }
}

async function getEWFilesCompanyPublic(companyId) {
  try {
    const res = await apiClient.get(`/googlestorage/ew/company/public/${companyId}`);
    return res;
  } catch (error) {
    return error;
  }
}
async function getEWFilesCompanyPrivate(companyId) {
  try {
    const res = await apiClient.get(`/googlestorage/ew/company/private/${companyId}`);
    return res;
  } catch (error) {
    return error;
  }
}

async function getEWFilesGroup(companyId, groupId) {
  try {
    const res = await apiClient.get(`/googlestorage/ew/group/${companyId}/${groupId}`);
    return res;
  } catch (error) {
    return error;
  }
}

async function getEWFilesStudent(companyId, studentId) {
  try {
    const res = await apiClient.get(`/googlestorage/ew/student/${companyId}/${studentId}`);
    return res;
  } catch (error) {
    return error;
  }
}

async function getEWFilesTeacher(teacherId) {
  try {
    const res = await apiClient.get(`/googlestorage/ew/teacher/${teacherId}`);
    return res;
  } catch (error) {
    return error;
  }
}
async function getEWFilesTeacherGlobal() {
  try {
    const res = await apiClient.get('/googlestorage/ew/teacher/global');
    return res;
  } catch (error) {
    return error;
  }
}

async function getResources() {
  try {
    const res = await apiClient.get('/googlestorage/resources');
    return res;
  } catch (error) {
    return error;
  }
}

async function uploadFile(folder, companyName, subfolder, file) {
  try {
    const res = await apiClient.post(`/googlestorage/upload/${folder}/${companyName}/${subfolder}`, file);
    return res;
  } catch (error) {
    return error;
  }
}

async function uploadFileEW(file) {
  try {
    const res = await apiClient.post('/googlestorage/upload/ew', file);
    return res;
  } catch (error) {
    return error;
  }
}

async function uploadResource(file) {
  try {
    const res = await apiClient.post('/googlestorage/resources', file);
    return res;
  } catch (error) {
    return error;
  }
}

async function uploadExamSubject(file) {
  try {
    const res = await apiClient.post('/googlestorage/exams', file);
    return res;
  } catch (error) {
    return error;
  }
}

async function downloadFile(filename) {
  try {
    const res = await apiClient.post('/googlestorage/download', { filename });
    return res;
  } catch (error) {
    return error;
  }
}

async function deleteFile(filename) {
  try {
    const res = await apiClient.post('/googlestorage/delete', { filename });
    return res;
  } catch (error) {
    return error;
  }
}

const googleStorageServices = {
  getFiles,
  getFilesExams,
  uploadFile,
  uploadFileEW,
  uploadResource,
  uploadExamSubject,
  downloadFile,
  getResources,
  deleteFile,
  getEWFilesGlobal,
  getMWFilesGlobal,
  getEWFilesCompanyPublic,
  getEWFilesCompanyPrivate,
  getEWFilesGroup,
  getEWFilesStudent,
  getEWFilesTeacher,
  getEWFilesTeacherGlobal,
};

export default googleStorageServices;
